
import { Component, Mixins } from 'vue-property-decorator'
import { Getter } from 'vuex-class'
import scroll from '@/mixins/scroll'

import { imagePreview } from '@/utils/util'
import { chooseFile } from '@/utils/h5ToApp'

import timePopup from './template/timePopup.vue'
import bankTypePopup from './template/bankTypePopup.vue'
import addrPopup from './template/addrPopup.vue'
import bankPopup from './template/bankPopup.vue'
import bankBranchPopup from './template/bankBranchPopup.vue'
import supplierList from './template/supplierList.vue'
import { updateStore, getStoreInfo, bindingNewSupplier } from '@/api/ccx'

@Component({
  name: 'EditCCXStore',
  components: {
    timePopup,
    bankTypePopup,
    addrPopup,
    bankPopup,
    bankBranchPopup,
    supplierList
  }
})
export default class EditCCXStore extends Mixins(scroll) {
  @Getter companyId!: string

  imagePreview = imagePreview
  active = 0
  tabList = [
    {
      name: '店铺基本信息',
      id: 0
    },
    {
      name: '收款账户信息',
      id: 1
    },
    {
      name: '绑定供应商',
      id: 2
    }
  ]
  // 店铺基本信息表单
  form0 = {
    storeHeadPortrait: '', // 店铺头像
    storeEntityPicture: '', // 店铺实体图
    storeName: '', // 店铺名称
    address: '', // 所在地区
    receiveAddressDtl: '', // 详细地址
    pickupStartTime: '', // 营业开始时间
    pickupEndTime: '', // 营业结束时间
    takeStartTime: '', // 提货开始时间
    takeEndTime: '', // 提货结束时间
    receiveMobile: '', // 联系电话
    receiveMan: '', // 联系人
    longitude: 0, // 经度
    latitude: 0, // 纬度
    jrAddress: '' // 地图返回地址（只有省市区）
  }
  // 收款账户信息表单
  form1 = {
    bankType: 1, // 账户类型(1:公司账户2:私人账户)
    bankRecipients: '', // 收款人/公司
    bankNumber: '', // 收款卡号
    bankCity: '', // 收款卡银行开户地
    bankCard: '', // 收款卡银行
    bankId: '', // 收款卡银行id
    bankBranch: '' // 收款卡银行支行
  }
  cityId = '' // 开户地id
  // 绑定供应商表单
  form2 = {
    ccxVendorCoding: '' // 供应商编号
  }
  isShowBind = false // 显示绑定新供应商

  timePopupType = 1 // 1营业 2提货

  // 活跃表单
  get activeForm() {
    return this[`form${this.active}`]
  }

  // 营业时间（回显）
  get pickupTime() {
    const { pickupStartTime, pickupEndTime } = this.activeForm
    return pickupStartTime && pickupEndTime
      ? `${pickupStartTime} 至 ${pickupEndTime}`
      : ''
  }

  // 提货时间（回显）
  get takeTime() {
    const { takeStartTime, takeEndTime } = this.activeForm
    return takeStartTime && takeEndTime
      ? `${takeStartTime} 至 ${takeEndTime}`
      : ''
  }

  // 账户类型（回显）
  get banTypeText() {
    // (1:公司账户2:私人账户)
    return this.activeForm.bankType == 1 ? '公司账户' : '私人账户'
  }

  created() {
    // 获取店铺详情数据
    getStoreInfo({ storeId: this.companyId }).then((res) => {
      let storeData = res?.data || {}
      const { pickupStartTime, pickupEndTime, takeStartTime, takeEndTime } =
        storeData
      // 去掉时间字符串中的秒
      const formatTime = (time) => time?.replace(/:00$/, '') || ''
      storeData = {
        ...storeData,
        pickupStartTime: formatTime(pickupStartTime),
        pickupEndTime: formatTime(pickupEndTime),
        takeStartTime: formatTime(takeStartTime),
        takeEndTime: formatTime(takeEndTime)
      }
      this.form0 = { ...storeData }
      this.form1 = { ...storeData }
    })
  }

  afterRead(prop) {
    const data = {
      fileType: '1',
      maxFileCount: '1'
    }
    chooseFile(data).then((res: any) => {
      this.activeForm[prop] = res[0].filePath
    })
  }

  // 调用原生enterSelectAddress方法去选择收获地址
  selectAddress() {
    // 防止键盘高度没收回，跳出去回来后页面高度变化
    setTimeout(() => {
      const data = {
        customerId: this.companyId,
        isShowTemporary: false, // 是否展示临时地址信息 传false就是不展示，true就是展示
        title: '请选择所在地区'
      }
      this.$bridge.callHandler('enterSelectAddress', { data }, (res) => {
        const data = !res ? {} : JSON.parse(res)
        const {
          address,
          addressDtl,
          receiveMobile,
          receiveMan,
          longitude,
          latitude,
          jraddress
        } = data
        this.activeForm.address = address
        this.activeForm.receiveAddressDtl = addressDtl
        this.activeForm.receiveMobile = receiveMobile
        this.activeForm.receiveMan = receiveMan
        this.activeForm.longitude = longitude
        this.activeForm.latitude = latitude
        this.activeForm.jrAddress = jraddress
      })
    }, 100)
  }

  // 申请绑定
  onBind() {
    const form = `form${this.active}`
    ;(this.$refs[form][0] as any)
      .validate()
      .then(() => {
        const params = {
          ...this.activeForm,
          storeId: this.companyId
        }
        bindingNewSupplier(params).then(() => {
          this.$toast.success({
            message: `申请成功`,
            duration: 2000,
            onClose: () => {
              this.activeForm.ccxVendorCoding = ''
              this.isShowBind = false
            }
          })
        })
      })
      .catch((res) => {
        this.$toast(res[0].name + '不能为空')
      })
  }

  // 取消
  onBack() {
    this.$router.back()
  }

  // 保存
  onSubmit() {
    const { storeHeadPortrait, storeEntityPicture } = this.activeForm
    if (!storeHeadPortrait) {
      this.$toast('请上传店铺头像')
      return false
    }
    if (!storeEntityPicture) {
      this.$toast('请上传店铺实体图片')
      return false
    }
    const form = `form${this.active}`
    ;(this.$refs[form][0] as any)
      .validate()
      .then(() => {
        const { pickupStartTime, pickupEndTime, takeStartTime, takeEndTime } =
          this.activeForm
        const params = {
          ...this.activeForm,
          pickupStartTime: `${pickupStartTime}:00`,
          pickupEndTime: `${pickupEndTime}:00`,
          takeStartTime: `${takeStartTime}:00`,
          takeEndTime: `${takeEndTime}:00`
        }
        updateStore(params).then(() => {
          this.$toast.success({
            message: `保存成功`,
            duration: 2000,
            onClose: () => {
              this.$router.back()
            }
          })
        })
      })
      .catch((res) => {
        this.$toast(res[0].name + '不能为空')
      })
  }

  // 时间
  // type(1营业 2提货)
  onShowTimePopup(type) {
    this.timePopupType = type
    let params
    // 营业时间
    if (type === 1) {
      const { pickupStartTime, pickupEndTime } = this.activeForm
      params = { startTime: pickupStartTime, endTime: pickupEndTime }
    } else {
      // 提货时间
      const { takeStartTime, takeEndTime } = this.activeForm
      params = { startTime: takeStartTime, endTime: takeEndTime }
    }
    ;(this.$refs.timePopupRef as any).showPop(params)
  }

  onTimePopupConfirm({ startTime, endTime }) {
    // 营业时间
    if (this.timePopupType === 1) {
      this.activeForm.pickupStartTime = startTime
      this.activeForm.pickupEndTime = endTime
    } else {
      // 提货时间
      this.activeForm.takeStartTime = startTime
      this.activeForm.takeEndTime = endTime
    }
  }

  // 账户类型
  onShowBankTypePopup() {
    ;(this.$refs.bankTypePopupRef as any).showPop()
  }

  onBankTypeConfirm(value) {
    this.activeForm.bankType = value
  }

  // 开户地
  onShowAddrPopup() {
    ;(this.$refs.addrPopupRef as any).showPop()
  }

  onAddrPopupConfirm({ addressId, addressName }) {
    this.cityId = addressId
    this.activeForm.bankCity = addressName
  }

  // 银行
  onShowBankPopup() {
    ;(this.$refs.bankPopupRef as any).showPop()
  }

  onBankPopupConfirm({ bankId, bankName }) {
    this.activeForm.bankId = bankId
    this.activeForm.bankCard = bankName
  }

  // 银行支行
  onShowBankBranchPopup() {
    const { bankCity, bankCard } = this.activeForm
    if (!bankCity) {
      this.$toast('请先选择收款卡银行开户地')
      return false
    }
    if (!bankCard) {
      this.$toast('请先选择收款卡银行')
      return false
    }
    const params = {
      provinceName: this.getProvinceName(bankCity),
      branchName: bankCard
    }
    ;(this.$refs.bankBranchPopupRef as any).showPop(params)
  }

  onBankBranchPopupConfirm(value) {
    this.activeForm.bankBranch = value
  }

  // 通过地址详情获取province的值
  getProvinceName(addressDtl: any) {
    var reg = /.+?(省|市|自治区|自治州|县|区)/
    return addressDtl.match(reg)[0]
  }
}
